var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headBackWrap"},[_c('div',{staticClass:"headerWrap"},[_c('i',{staticClass:"el-icon-back",on:{"click":_vm.goPath}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }